import axios from "axios";
import {db_url, url_sale} from "../url";

export default function DB_Sale(token) {
    const add_url = '/document'

    const formData = new FormData();
    formData.append('token', token)

    const appendToken = (data) => {
        const fd = new FormData();
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    // const getSales = (data) => {
    //     return axios.post(url_sales, appendToken(data))
    // }

    const getSales = (controller, search) => {
        // return axios.post(url_sales, appendToken(data))
        return axios.get(db_url + add_url + '/sales', {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + add_url + '/sales', {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getSale = (id) => {
        return axios.get(url_sale,  {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const blockSale = (data) => {
        return axios.post(db_url + add_url + `/sale/block`, data, {
            headers: {
                Authorization: token
            }
        })
    }

    const changeStatus = (data) => {
        return axios.post(db_url + add_url + `/sale/status`, data, {
            headers: {
                Authorization: token
            }
        })
    }

    const updateInvoiceDetails = (data) => {
        return axios.patch(db_url + add_url + `/sale`, data, {
            headers: {
                Authorization: token
            }
        })
    }

    const updateInvoice = (data) => {
        return axios.put(db_url + add_url + `/sale`, data, {
            headers: {
                Authorization: token
            }
        })
    }


    return {
        getSales,
        getSale,
        blockSale,
        changeStatus,
        updateInvoiceDetails,
        updateInvoice,
    }
}
